import { render } from "./Stopwatch.vue?vue&type=template&id=3dc5340e&scoped=true"
import script from "./Stopwatch.vue?vue&type=script&lang=js"
export * from "./Stopwatch.vue?vue&type=script&lang=js"

import "./Stopwatch.vue?vue&type=style&index=0&id=3dc5340e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc5340e"]])

export default __exports__